import './app.css'
import App from './App.svelte'
// import App from './SimpleApp.svelte'
import { mount } from 'svelte'

const target = document.getElementById('app')!

const app = mount(App, {
  target: target,
})

export default app